export class Validation {
    static password (pass) {
        return pass && pass.trim().length >= 8;
    }

    static fullName (name) {
        return name && name.trim().length >= 2;
    }

    static email (eml) {
        var ptr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return ptr.test(eml);
    }

    static phone (phn) {
        return Validation.onlyNumbersNotFloat(phn);
    }

    static onlyNumbers (num) {
        var ptr = /(\d+(\.\d+)?)/g; // include float number
        return ptr.test(num);
    }

    static onlyNumbersNotFloat(num) {
        var ptr = /\D+/g;
        return !ptr.test(num);
    }

    static imageFileType(type, accept) {
        type = type.replace('image/', '');
        return accept.indexOf(type) > -1;
    }

    static fileSize(size, limitSize) {
        return size < limitSize;
    }
}


// WEBPACK FOOTER //
// ./src/helper/validation.js